import { useMutation, useQueryClient } from "@tanstack/react-query";
import { freeLectureRedeem as freeLectureRedeemAPI } from "@/services/apiLecture";
import toast from "react-hot-toast";

export function useFreeLectureRedeem() {
    const queryClient = useQueryClient();
    const {
        mutate: freeLectureRedeem,
        isPending,
        error,
    } = useMutation({
        mutationFn: freeLectureRedeemAPI,
        onSuccess: () => {
            toast.success("تم إضافه المحاضره بنجاح");

            queryClient.invalidateQueries({ active: true });
        },

        onError: (err) => {
            console.log(err);
            toast.error(err.response.data.message);
        },
    });

    return { freeLectureRedeem, isPending, error };
}
